<template>
  <ParentPage
    v-if="menu.length"
    class="ReleaseNotes"
    :menu="menu"
    :root-route-name="rootRouteName"
  />
</template>

<script>
// import { mapGetters } from 'vuex';
import ParentPage from '@/components/ParentPage.vue';

export default {
  name: 'ReleaseNotes',
  components: {
    ParentPage
  },
  data() {
    return {
      releaseNotes: [],
      rootRouteName: 'ReleaseNotes'
    };
  },
  computed: {
    // ...mapGetters('user', ['canAccessManuals']),
    menu() {
      const releaseNotesList = [];
      this.releaseNotes?.map(releaseNote => {
        const data = releaseNote.data['nl-NL'];

        const item = {
          type: 'link',
          label: data.title,
          to: {
            name: 'ReleaseNotePage',
            params: { uuid: releaseNote.uuid }
          },
        };

          releaseNotesList.push(item);
      });
      return releaseNotesList;
    }
  },
  async created() {
    const token = await this.$auth.getTokenSilently();
    const api = await fetch('/api/get-release-notes', {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    if (api.ok) {
      this.releaseNotes = await api.json();
    }
  }
};
</script>
